import type Flicking from '@egjs/flicking'
import { EVENTS, type Plugin } from '@egjs/flicking'

/**
 * Custom parallax plugin for Flicking.
 */
class Parallax implements Plugin {
  private _flicking: Flicking | null
  private _withOpacity: boolean

  /* Options  */
  private _selector: string
  private _scale: number

  public get selector() {
    return this._selector
  }

  public get scale() {
    return this._scale
  }

  public set selector(val: string) {
    this._selector = val
  }

  public set scale(val: number) {
    this._scale = val
  }

  /**
   * @example
   * ```ts
   * flicking.addPlugins(new Parallax("img", 1));
   * ```
   */
  public constructor(selector = '', scale = 1, withOpacity?: boolean) {
    this._flicking = null
    this._selector = selector
    this._scale = scale
    this._withOpacity = withOpacity || false
  }

  public init(flicking: Flicking): void {
    if (this._flicking) {
      this.destroy()
    }

    this._flicking = flicking

    flicking.on(EVENTS.MOVE, this._onMove)
    flicking.on(EVENTS.AFTER_RESIZE, this.update)
    this._onMove()
  }

  public destroy(): void {
    if (!this._flicking) return

    this._flicking.off(EVENTS.MOVE, this._onMove)
    this._flicking = null
  }

  public update = (): void => {
    this._onMove()
  }

  private _onMove = (): void => {
    const flicking = this._flicking

    if (!flicking) return

    const panels = flicking.panels

    panels.forEach((panel) => {
      const progress = panel.outsetProgress
      const el = panel.element
      const target = this._selector
        ? el.querySelector<HTMLElement>(this._selector)!
        : el
      const position = progress * -50
      target.style.transform = `translateX(${position}%)`
    })
  }
}
export default Parallax
